export enum IncidentTab {
    DETAILS_TAB = 0,
    NOTES_TAB = 1,
    MOBILITY_STRATEGIES_TAB = 2,
    KEY_MESSAGES_TAB = 3,
    PIO_TAB = 4,
  }
  
  